import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'

import { SectionTitle, SectionWrapper } from '../elements'
import TestimonialScroller from './testimonial-scroller'

const OuterWrapper = styled.div`
  background-color: ${colors.blue96};
`

const StyledSectionWrapper = styled(SectionWrapper)`
  @media (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 56px 24px 80px 24px;
  }
`

const TitleSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 56px;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    margin-bottom: 24px;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const SubTitle = styled.p`
  font-family: Inter, sans-serif;
  font-size: 16px;
  line-height: 24px;

  color: ${colors.grey16};
  margin: 0;
`

const TestimonialsSection = () => {
  const { t } = useTranslation('landlords')

  return (
    <OuterWrapper>
      <StyledSectionWrapper>
        <TitleSectionWrapper>
          <TitleWrapper>
            <SectionTitle marginBottom={20}>
              {t(`landlords:We're changing the way Canada rents`)}
            </SectionTitle>
            <SubTitle>
              {t(
                `landlords:See why thousands of landlords and property managers love our rental management features.`
              )}
            </SubTitle>
          </TitleWrapper>
        </TitleSectionWrapper>
        <TestimonialScroller />
      </StyledSectionWrapper>
    </OuterWrapper>
  )
}

export default TestimonialsSection
